"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DubbingListRequestDubbingStatus = void 0;
exports.DubbingListRequestDubbingStatus = {
    Dubbing: "dubbing",
    Dubbed: "dubbed",
    Failed: "failed",
};
